import { MigrationInterface, QueryRunner } from 'typeorm'

export class IncreaseCustomerNameLength1763707572498 implements MigrationInterface {
	name = 'IncreaseCustomerNameLength1763707572498'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "reservation" ALTER COLUMN "customerName" TYPE varchar(240)`)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "reservation" ALTER COLUMN "customerName" TYPE varchar(60)`)
	}
}
